import { NylasState } from '../../types';

/**
 * Build the state string for v3
 * @param {NylasState} state - State object of Nylas v3
 * keywords: nylasstate
 */
const buildStateString = (state: NylasState): string =>
  encodeURIComponent(
    `${state.entityType}|${state.entityId}|${state.accountId}`,
  );

export default buildStateString;
